export default __webpack_public_path__ + "static/media/colored-logo.9b9e2315.svg";